import { useState } from 'react';
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material';
import {
  Tune as ParametersIcon, Gavel as CausesIcon, Sync as TalanaIcon, Description as TemplatesIcon,
  Assignment as IzydocsIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ErpParameterSetsTab from './ErpParameterSetsTab';
import ErpHiringCausesTab from './ErpHiringCausesTab';
import ErpTalanaSyncTab from './ErpTalanaSyncTab';
import ErpDocumentTemplatesTab from './ErpDocumentTemplatesTab';
import ErpIzydocsFormatsTab from './ErpIzydocsFormatsTab';

/**
 * Configuración del modo ERP — nivel organización (decisión 1).
 * Fase 2: parámetros del motor de cálculo por período.
 * Fase 3: catálogo de causales de contratación.
 * Integración Talana (fase A): sincronización de catálogos desde Talana.
 * Plantillas Word (PLAN_ERP.md §15, fase B1): contrato tipo en Word (PDF de Amanda).
 * Formatos Izydocs (§15.4, fase B2): catálogo de solo lectura de las plantillas de Izydocs.
 * (Los cargos son sección propia del menú: /erp/job-titles.)
 */
const ErpConfigurationLayout = () => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
        {t('erp.config.title')}
      </Typography>

      <Box sx={{ display: 'flex', gap: 3 }}>
        <Paper sx={{ width: 220, flexShrink: 0 }}>
          <Tabs
            orientation="vertical"
            value={currentTab}
            onChange={(e, v) => setCurrentTab(v)}
            sx={{ borderRight: 1, borderColor: 'divider' }}
          >
            <Tab
              icon={<ParametersIcon />}
              iconPosition="start"
              label={t('erp.config.tabs.parameters')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
            <Tab
              icon={<CausesIcon />}
              iconPosition="start"
              label={t('erp.config.tabs.hiringCauses')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
            <Tab
              icon={<TalanaIcon />}
              iconPosition="start"
              label={t('erp.config.tabs.talana')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
            <Tab
              icon={<TemplatesIcon />}
              iconPosition="start"
              label={t('erp.config.tabs.templates')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
            <Tab
              icon={<IzydocsIcon />}
              iconPosition="start"
              label={t('erp.config.tabs.izydocs')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
          </Tabs>
        </Paper>

        <Box sx={{ flexGrow: 1 }}>
          {currentTab === 0 && <ErpParameterSetsTab />}
          {currentTab === 1 && <ErpHiringCausesTab />}
          {currentTab === 2 && <ErpTalanaSyncTab />}
          {currentTab === 3 && <ErpDocumentTemplatesTab />}
          {currentTab === 4 && <ErpIzydocsFormatsTab />}
        </Box>
      </Box>
    </Box>
  );
};

export default ErpConfigurationLayout;
